import React, { Component, Fragment } from 'react'
import debounceRender from 'react-debounce-render'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import { Link } from 'react-router-dom'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import EditorFormatListBulleted from 'material-ui/svg-icons/editor/format-list-bulleted'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import TablePagination from '@material-ui/core/TablePagination'
import { contentActions, confirmActions, messageActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import Visibility from '@material-ui/icons/Visibility'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import LogsModal from './LogsModal'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import ExportButton from '../../components/ExportButton'

class ListTable extends Component {
  state = {
    debounce: undefined,
    previewIsOpen: false,
    modalLogsOpen: false
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchContents, term, filter } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchContents({ page, perPage, order, term, filter })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchContents } = this.props
    fetchContents()
  }

  renderActions = content => {
    const {
      deleteContent,
      addConfirm,
      token,
      restoreContent,
      openLogsModal,
      fetchLogs
    } = this.props

    return (
      <Fragment>
        {findPermission('logConteudos', token).ler && (
          <IconButton
            onClick={() => {
              openLogsModal()
              fetchLogs(content._id)
            }}
          >
            <EditorFormatListBulleted />
          </IconButton>
        )}

        {readOnly(content.tipo, token) &&
          !content.deletedAt && (
            <IconButton component={Link} to={`/conteudos/${content._id}`}>
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!content.deletedAt && findPermission(content.tipo, token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props
              addConfirm({
                confirmMessage: 'Confirma a restauração deste conteúdo?',
                confirmFunction: () => {
                  restoreContent(content._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission(content.tipo, token).editar && (
              <IconButton component={Link} to={`/conteudos/${content._id}`}>
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('exportConteudos', token).ler &&
              content.exportFiles && <ExportButton contentId={content._id} />}

            {findPermission(content.tipo, token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props
                  addConfirm({
                    confirmMessage: 'Confirma a exclusão deste conteúdo?',
                    confirmFunction: () => {
                      deleteContent(content._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  handleChangePage = (event, page) => {
    const { handleChangePage } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { handleChangePerPage } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props

    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  typeFormatter = type => {
    switch (type) {
      case 'consulta_rapida_e_recomendacoes':
        return 'Consulta rápida e recomendações'
        break
      case 'diagnostico_e_tratamento':
        return 'Diagnóstico e tratamento'
        break
      case 'habilidades_clinicas':
        return 'Habilidades Clínicas'
        break
      default:
        return type || '---'
    }
  }

  render() {
    const {
      classes,
      contents = [],
      loadingContents,
      addConfirm,
      restoreContent,
      pagination,
      order,
      openLogsModal,
      fetchLogs
    } = this.props

    return (
      <Fragment>
        <Paper className={classes.wrapperTable} elevation={4}>
          {!!loadingContents && (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          )}

          <Table
            fixedHeader={true}
            width={'990px'}
            wrapperStyle={{
              display: 'flex',
              flexDirection: 'column',
              maxHeight: 'var(--crud-table-height)'
            }}
          >
            <TableHeader
              displaySelectAll={false}
              className={classes.tableHeader}
              adjustForCheckbox={false}
            >
              <TableRow>
                <TableHeaderColumn style={{ width: '150px' }}>
                  <TableSortLabel
                    active={((order || {}).column || '') === 'tipo'}
                    direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                    onClick={() => {
                      this.handleSortTable('tipo')
                    }}
                  >
                    Tipo de conteúdo
                  </TableSortLabel>
                </TableHeaderColumn>
                <TableHeaderColumn>
                  <TableSortLabel
                    active={((order || {}).column || '') === 'titulo'}
                    direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                    onClick={() => {
                      this.handleSortTable('titulo')
                    }}
                  >
                    Título
                  </TableSortLabel>
                </TableHeaderColumn>
                <TableHeaderColumn style={{ width: '100px' }}>
                  <TableSortLabel
                    active={((order || {}).column || '') === 'buscaPeso'}
                    direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                    onClick={() => {
                      this.handleSortTable('buscaPeso')
                    }}
                  >
                    Peso de Busca
                  </TableSortLabel>
                </TableHeaderColumn>
                <TableHeaderColumn style={{ width: '187px' }}>Ações</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false} className={classes.tableBody}>
              {(contents || []).length ? (
                (contents || []).map(content => {
                  return (
                    <TableRow key={content._id}>
                      <TableRowColumn
                        className={classes.capitalizeField}
                        style={{ width: '150px' }}
                      >
                        {this.typeFormatter(content.tipo)}
                      </TableRowColumn>
                      <TableRowColumn>
                        {content.titulo || content.principioAtivo || '---'}
                      </TableRowColumn>
                      <TableRowColumn style={{ width: '100px' }}>
                        {content.buscaPeso}
                      </TableRowColumn>
                      <TableRowColumn
                        style={{ width: '187px', textOverflow: 'initial !important' }}
                      >
                        {this.renderActions(content)}
                      </TableRowColumn>
                    </TableRow>
                  )
                })
              ) : (
                <TableRow>
                  <TableRowColumn>
                    <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                      {!!loadingContents ? 'Carregando...' : 'Não há registros.'}
                    </Typography>
                  </TableRowColumn>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <div className={classes.paginationWrapper}>
            <div className={classes.page}>Página: {pagination.page + 1}</div>
            <TablePagination
              component="div"
              className={classes.pagination}
              labelRowsPerPage="Itens por página"
              labelDisplayedRows={({ from, to, count, page }) => {
                return `Exibindo de ${from} a ${to} de ${count}`
              }}
              count={pagination.length}
              rowsPerPage={pagination.rowsPerPage}
              rowsPerPageOptions={[25, 50, 100]}
              page={pagination.page}
              backIconButtonProps={{
                'aria-label': 'Página anterior'
              }}
              nextIconButtonProps={{
                'aria-label': 'Próxima página'
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </div>
        </Paper>

        <LogsModal classes={classes} />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    content: state.content.content,
    contents: state.content.contents,
    loadingContents: state.content.loadingContents,
    token: state.auth.token,
    pagination: state.content.contentsPagination,
    order: state.content.order,
    modalLogsOpen: state.content.modalLogsOpen
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchContent: id => {
      dispatch(contentActions.fetchContent(id))
    },
    fetchContents: options => {
      dispatch(contentActions.fetchContents(options))
    },
    deleteContent: id => {
      dispatch(contentActions.deleteContent(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    restoreContent: id => {
      dispatch(contentActions.restoreContent(id))
    },
    handleChangePage: page => {
      dispatch(contentActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(contentActions.handleChangePerPage(perPage))
    },
    changeOrderColumn: column => {
      dispatch(contentActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(contentActions.changeOrderDirection(direction))
    },
    fetchLogs: id => {
      dispatch(contentActions.fetchLogs(id))
    },
    openLogsModal: () => {
      dispatch(contentActions.openLogsModal())
    },
    closeLogsModal: () => {
      dispatch(contentActions.closeLogsModal())
    }
  }
}

export default connect(
  state => ({
    term: state.searchTable.term,
    filter: (state.searchTable.filter || {}).value
  }),
  null
)(
  debounceRender(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(withStyles(listTableStyle)(ListTable)),
    450,
    { leading: false }
  )
)



// WEBPACK FOOTER //
// ./src/containers/Content/ListTable.js